module.exports = __webpack_public_path__ + "media/images/backgrounds/background-hero-c43aec8a08bbb4be7f31ac1bea1eb655.jpg";